import { types } from '../types/types';

export const cartReducer = (state, action ) => {

    switch ( action.type ) {
        case types.add:
            return {
                ...state,
                items: [...state.items, {id: action.payload.id}]
            };

        case types.remove:
            return {
                ...state,
                items: state.items.filter((item) => item.id != action.payload.id)
            };

        case types.update:
            return {
                ...action.payload
            }

        default:
            return state;
    }
}